<template>
  <div class="q-pa-md">
    <q-table
      grid
      :title="tab"
      :rows="rows"
      :columns="columns"
      row-key="name"
      :filter="filter"
      hide-header
      v-model:pagination="pagination"
      :rows-per-page-options="rowsPerPageOptions"
    >
      <template v-slot:top-right v-if="tab === '所有訊息'">
        <q-input
          borderless
          dense
          debounce="300"
          v-model="filter"
          placeholder="Search"
        >
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>

      <template v-slot:item="props">
        <div class="q-pa-xs col-xs-12 col-sm-12 col-md-6">
          <q-card style="height: 50vh; overflow-y: auto;">
            <q-card-section class="text-center">
              {{ props.row.date }}
              <br />
              <strong>{{ props.row.post }}</strong>
            </q-card-section>
            <q-separator />
            <q-card-section class="q-pt-none">
              <div v-html="props.row.description"></div>
            </q-card-section>
          </q-card>
        </div>
      </template>
    </q-table>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { ref, computed, watch } from "vue";

const columns = [
  {
    name: "date",
    required: true,
    label: "Date",
    align: "left",
    field: row => row.date,
    format: val => `${val}`,
    sortable: true
  },
  {
    name: "post",
    align: "center",
    label: "Post",
    field: "post",
    sortable: true
  },
  {
    name: "category",
    align: "right",
    label: "Category",
    field: "category",
    sortable: true
  }
];

const rows = [
  {
    date: "2026.08.31",
    category: "比賽獲獎",
    post: `狂賀 2026 第七屆世界皮革創意設計大賽`,
    description: `
    詹益安同學作品RE: GLOVE榮獲<br />
    2026 第七屆世界皮革創意設計大賽<br />
    鞋類銀獎<br />
    `
  },
  {
    date: "2026.08.12",
    category: "比賽獲獎",
    post: `賀 2026 KFA高雄時尚大賞初選入圍服經系兩組同學入圍`,
    description: `
    溫博任/ PREP ROOM / 浴備而戰<br />
    張羽昕/ iomyo / PirAtE GaMe<br />
    第7屆「2026 KFA高雄時尚大賞」總獎金高達125萬元，<br />
    最高可抱回65萬元（含金賞創業獎勵金），<br />
    並首設「國際市場潛力獎」與「永續時尚賞」。<br />
    決賽暨頒獎典禮：2026年11月14日（暫定）<br />
    讓我們一起為兩位入圍同學鼓勵及加油<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4078_7908605_51725.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4078_7908605_51725.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4079_7416953_51773.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4079_7416953_51773.jpg"></a>
    `
  },
  {
    date: "2026.08.12",
    category: "比賽獲獎",
    post: `狂賀 2026 第七屆世界皮革創意設計大賽入圍`,
    description: `
    詹益安/ RE: GLOVE<br />
    115/8/28決賽<br />
    115/8/29頒獎<br />
    <a target="_blank" href="https://rlsd.internationaldesigncomp.com/projects/a843f9f0-f684-4ac8-af71-24fd062afba7/">人氣投票連結🔗</a><br />
    請同學一起動起來  為小安同學加加油<br />
    沒有帳號的同學也可以用訪客模式幫忙投票!!!!<br />
    照片出處 Real Leather. Stay Different.<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4076_8165926_51316.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4076_8165926_51316.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4080_8861853_51865.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4080_8861853_51865.jpg"></a>
    `
  },
  {
    date: "2026.05.14",
    category: "系務活動",
    post: `輕軌快閃!!!+大港橋`,
    description: `
   「時尚是城市的表情，流行是城市的人生活的樣態」，服裝則是上述論述在可見的真實世界裡的具體表現～<br />

    實踐大學服飾設計與經營學系特輯<br />
    高雄輕軌~駁二藝術特區大港橋 動態快閃<br />
    2026/5/14(四) 上午10:00-11:00<br />
    在搭乘著高雄輕軌欣賞優美市景的同時<br />
    有著一群懷抱夢想的大學生<br />
    穿著著自己設計的服裝 走向大家<br />
    希望大家為這一群學生加油打氣<br />
    期待我們今天早上高雄輕軌見<br />
    
    直播平台：<a target="_blank" href="https://youtube.com/live/jXKHl4JxvsY?feature=share">https://youtube.com/live/jXKHl4JxvsY?feature=share</a><br />
    
    實踐大學高雄校區 服飾設計與經營學系<br />
    照片出處 : 駁二藝術特區提供
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4054_2914999_57453.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4054_2914999_57453.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4055_1974944_57481.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4055_1974944_57481.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4056_9336189_57499.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4056_9336189_57499.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4057_2385531_57512.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4057_2385531_57512.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4058_3438447_57525.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4058_3438447_57525.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4059_4813987_57541.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4059_4813987_57541.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4060_9279267_57559.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4060_9279267_57559.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4061_8161789_57579.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4061_8161789_57579.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4062_6413684_57600.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4062_6413684_57600.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4063_6905439_57611.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4063_6905439_57611.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4064_2903322_57621.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4064_2903322_57621.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4065_7838829_57632.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4065_7838829_57632.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4066_3122830_57643.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_4066_3122830_57643.jpg"></a>
    `
  },
  {
    date: "2026.01.30",
    category: "比賽獲獎",
    post: `2026第十屆儒鴻服裝設計競賽榮獲8獎項及校園團體獎`,
    description: `
    第二名張羽昕(作品名稱-登高)<br />
    第二名溫博任(作品名稱-破曉臨界)<br />
    第三名莊松偉(作品名稱-自適形體)<br />
    第三名曾冠叡(作品名稱-定弦)<br />
    佳作卓勁芯(作品名稱-軌跡)<br />
    佳作鍾欣璇(作品名稱-微光之徑)<br />
    最佳市場潛力獎吳沛錞(作品名稱--時序流線)<br />
    最佳市場潛力獎李韋翰(作品名稱-戰甲)<br />
    高雄校區獲得校園團體獎（獎金50萬）<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3985_5418557_57047.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3985_5418557_57047.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3977_284763_56856.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3977_284763_56856.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3978_2692942_56877.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3978_2692942_56877.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3979_7388289_56898.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3979_7388289_56898.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3980_9208047_56927.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3980_9208047_56927.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3981_871178_56948.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3981_871178_56948.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3982_869126_56965.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3982_869126_56965.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3983_3440028_56990.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3983_3440028_56990.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3984_557349_57022.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3984_557349_57022.jpg"></a>
    `
  },
  {
    date: "2026.01.20",
    category: "系務活動",
    post: `淨零碳規劃管理師`,
    description: `
    恭喜~服經系劉錦淑同學、高靖雯同學通過淨零碳規劃管理師初級能力鑑定合格<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3969_2879925_52238.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3969_2879925_52238.jpg"></a>
    `
  },
  {
    date: "2026.01.20",
    category: "系務活動",
    post: `海上絲路計畫`,
    description: `
    黃崇信助理教授通過教育部新南向學海築夢計畫-暹羅行築夢-海上絲路計畫申請案<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3968_6992343_52211.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3968_6992343_52211.jpg"></a>
    `
  },
  {
    date: "2026.01.20",
    category: "設計工作營",
    post: `設計探索體驗工作營`,
    description: `
    國際級攝影師吉村和敏(KAZUTOSHI YOSHIMURA)寫真家，赴實踐大學服經系國際工作營-日本媒體的新聞報導。<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3967_3508319_52280.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3967_3508319_52280.jpg"></a>
    `
  },
  {
    date: "2025.12.23",
    category: "比賽獲獎",
    post: `2025KFA高雄時尚大賞獲獎`,
    description: `
    恭喜服經系系友江糠耀&廖林晴繼10月入圍設計新人獎決賽後，<br />
    於2025年高雄時尚大賞再度榮獲設計新秀賞(獎金4萬)+評審團特別獎(獎金5萬)兩個大獎。<br />
    #高雄市政府青年局<br />
    #2025KFA高雄時尚大賞<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3946_743159_33600.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3946_743159_33600.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3947_7893539_33617.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3947_7893539_33617.jpg"></a>
    `
  },
  {
    date: "2025.11.01",
    category: "系務活動",
    post: `服經系系周會`,
    description: `
    <br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3896_1120604_80919.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3896_1120604_80919.jpg"></a>
    `
  },
  {
    date: "2025.11.01",
    category: "設計工作營",
    post: `設計探索體驗工作營 *2025國際工作營Part07-服飾設計與表現技法工作坊*`,
    description: `
    授課教師: <br />
    日本文化學園 高村是州 教授<br />
    專業翻譯: <br />
    文化學園國際交流處 郭乃嘉 老師<br />
    研習日期:2025/11/22-11/24<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3894_9296386_80302.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3894_9296386_80302.jpg"></a>
    `
  },
  {
    date: "2025.11.01",
    category: "設計工作營",
    post: `設計探索體驗工作營 *2025國際工作營Part06-專業攝影工作坊*`,
    description: `
    授課教師 : <br />
    日本 吉村和敏攝影大師<br />
    研習日期:2025/10/31-11/03<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3895_300991_80339.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3895_300991_80339.jpg"></a>
    `
  },
  {
    date: "2025.10.11",
    category: "系務活動",
    post: `雲林縣農業剩餘資材資源化暨循環經濟推廣計畫—服裝設計競賽`,
    description: `
    入選名單公告<br />
    感謝各位同學對「114年雲林縣農業剩餘資材資源化暨循環經濟推廣計畫服裝設計競賽」的熱情支持！入選20組同學名單如下，特此公告，再次感謝大家的支持與參與。<br />
    錄取通知信件將由工作小組寄出，請入選設計師留意電子信箱，確認相關資訊！<br />
    序號/姓名/主題名稱<br />
    1. 鍾O璇 /殼映橋影<br />
    2. 周O孜 /白金綻放<br />
    3. 劉O瑜、賴O辰/雲野生息<br />
    4. 周O亦/雲林農韻<br />
    5. 詹O安/海潮迴響 雲林文蛤的永續織理<br />
    6. 詹O辰/Flourish<br />
    7. 陳O云/潮汐 • 紗映<br />
    8. 洪O瑜/築跡<br />
    9. 吳O愷/蚵護<br />
    10. 陳O韵/GoldEar<br />
    11. 粘O盈/海母屋<br />
    12. 陳O澔/漫遊雲林<br />
    13. 張O昕/耕 • 雲<br />
    14. 嚴O秦/潮光<br />
    15. 林O瑩/香火之路<br />
    16. 楊O鋅/豆蔓迴響<br />
    17. 温O任/殼然不同<br />
    18. 莊O偉/千禧回朔<br />
    19. 陳O羽/形祈<br />
    20. 劉O辰/潮生殼語<br />
    `
  },
  {
    date: "2025.09.21",
    category: "系務活動",
    post: `雲林縣農業剩餘資材資源化暨循環經濟推廣計畫—服裝設計競賽`,
    description: `
    ♻️ 循環時尚，由你啟動！<br />
    你是否想過，農業剩餘資材也能化身為時尚服裝？<br />
    邀請全國高中職與大專院校學生，用創意與永續理念，將「廢」變「美」！<br />
    📅 報名截止：114/10/05 (日)<br />
    ‼️報名表：<a target="_blank" href="https://forms.gle/P6m26G9VL1ojQs2u7">https://forms.gle/P6m26G9VL1ojQs2u7</a><br />
    （可點lG主頁連結進入，簡章及設計圖模板在表單最下方）
    💰 競賽獎金<br />
    •🥇 第一名：12,000 元<br />
    •🥈 第二名：9,000 元<br />
    •🥉 第三名：7,000 元<br />
    •🏅 佳作：5,000 元 × 2 名<br />
    •🎖️ 優選：1,000 元 × 15 名<br />
    📌 參賽資格<br />
    全國高中職校 / 大專院校在校生<br />
    🔥 不只是設計一件衣服，而是為環境設計一種可能。<br />
    現在，就讓你的作品成為循環經濟的新語言！<br />
    承辦單位 - 實踐大學服飾設計與經營學系<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3888_1447248_61086.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3888_1447248_61086.jpg"></a>
    `
  },
  {
    date: "2025.08.12",
    category: "比賽獲獎",
    post: `2025青春設計節創意設計競賽立體造型暨產品設計類/時尚設計組獲獎`,
    description: `
    李韋翰 - 評審團獎<br />
    張謀 - 優選獎<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3881_7520411_41987.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3881_7520411_41987.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3882_6597542_42003.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3882_6597542_42003.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3883_1997077_42017.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3883_1997077_42017.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3884_9920691_42033.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3884_9920691_42033.jpg"></a>
    `
  },
  {
    date: "2025.08.04",
    category: "系務活動",
    post: `2025日本移地教學`,
    description: `
    交流學校/參訪企業:<br />
    大阪萬國博覽會、石丸製麵、日本文化學園、愛麗絲商社與鈕釦博物館<br />
    移地教學日期:2025/06/24-07/04<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3879_375096_38057.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3879_375096_38057.jpg"></a>
    `
  },
  {
    date: "2025.08.04",
    category: "設計工作營",
    post: `設計探索體驗工作營 *2025國際工作營Part05-高階立裁工作營-立體魔法師*`,
    description: `
    授課教師 : <br />
    日本文化學院 森本慧 教師<br />
    研習日期:2025/05/04-05/05<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3878_2548909_38032.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3878_2548909_38032.jpg"></a>
    `
  },
  {
    date: "2025.08.04",
    category: "設計工作營",
    post: `設計探索體驗工作營 *2025國際工作營Part04-視覺商品設計與櫥窗展示工作坊*`,
    description: `
    授課教師 : <br />
    香港理工大學 黃穎聰 博士<br />
    研習日期:2025/04/25-04/27<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3877_6859888_38006.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3877_6859888_38006.jpg"></a>
    `
  },
  {
    date: "2025.07.23",
    category: "系務活動",
    post: "狂賀 服經系應屆畢業生江槺耀同學入圍2025時裝設計新人獎",
    description: `
    <a target="_blank" href="https://www.tfdaward.com/FNews/Detail?SN=131">決賽將於10月臺北時裝週舉行</a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3874_6103670_81379.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3874_6103670_81379.jpg"></a>
    `
  },
  {
    date: "2025.07.01",
    category: "系務活動",
    post: "狂賀 服經系114年度產業學院-淨零碳規劃管理師申請通過",
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3807_1194668_78221.png"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3807_1194668_78221.png"></a>
    `
  },
  {
    date: "2025.06.20",
    category: "系務活動",
    post: "2025實踐大學服飾設計與經營學系畢業展演初賽",
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3802_8116828_92633.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3802_8116828_92633.jpg"></a>
    `
  },
  {
    date: "2025.03.29",
    category: "臺北時裝週",
    post: "服經系畢業生周立恆CHOW des HOMME 臺北時裝週AW25 官方品牌秀",
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3779_3669612_62185.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3779_3669612_62185.jpg"></a>
    `
  },
  {
    date: "2025.03.28",
    category: "臺北時裝週",
    post:
      "服經系畢業生陳彥嘉INMORIES / COLLECTION 2025 RUNWAY SHOW 臺北時裝週 - 時裝秀",
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3780_2155321_62212.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3780_2155321_62212.jpg"></a>
    `
  },
  {
    date: "2025.03.10",
    category: "系務活動",
    post: "應日服經系聯合系周會-日本和服講座和服之美",
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3773_9660261_14915.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3773_9660261_14915.jpg"></a>
    `
  },
  {
    date: "2025.03.04",
    category: "系務活動",
    post: "114 年度教育部『藝術與設計菁英海外培訓計畫』說明會",
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3768_4100032_14572.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3768_4100032_14572.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3769_4483793_14701.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3769_4483793_14701.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3770_9964332_14718.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3770_9964332_14718.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3771_4228100_14736.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3771_4228100_14736.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3772_9512146_14751.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3772_9512146_14751.jpg"></a>
    `
  },
  {
    date: "2024.12.12",
    category: "學生創作",
    post: "2024服飾設計與經營學系畢業展演",
    description: `
    2024.12.14(六)衛武營國家藝術文化中心榕樹廣場
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3743_2839044_13896.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3743_2839044_13896.jpg"></a>
    <iframe width="100%" height="600" src="https://www.youtube.com/embed/videoseries?si=rmI4f1usxCo20_dx&amp;list=PL9MWofJKo1vWioB5mSiEPi36FeLDRNUuu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    `
  },
  {
    date: "2024.12.12",
    category: "設計工作營",
    post: `設計探索體驗工作營 *2024國際工作營Part03-DESIGN LED STEAM智能穿戴服飾設計研習營*`,
    description: `
    授課教師 : <br />
    香港理工大學Jeanne Tan教授<br />
    研習日期:2024/12/05-12/07<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3744_7202522_13911.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3744_7202522_13911.jpg"></a>
    `
  },
  {
    date: "2024.12.12",
    category: "學生創作",
    post: `周力恆品牌秀`,
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3745_2795959_13942.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3745_2795959_13942.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3746_5782923_13960.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3746_5782923_13960.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3747_8564661_13978.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3747_8564661_13978.jpg"></a>
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3748_3245663_13993.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3748_3245663_13993.jpg"></a>
    `
  },
  {
    date: "2024.10.28",
    category: "設計工作營",
    post: "設計探索體驗工作營 *2024國際工作營Part02-專業攝影工作坊*",
    description: `
    授課教師 : <br />
    日本寫真家 吉村和敏<br />
    研習日期:2024/11/29-12/01<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3712_7780430_17939.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3712_7780430_17939.jpg"></a>
    <iframe src="https://www.youtube.com/embed/tAtYublmm4I" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2024.10.28",
    category: "比賽獲獎",
    post: "恭喜🎉服經系榮獲2024世界皮革創意設計大賽獎項🏆",
    description: `
    張芸禎同學 榮獲 配飾設計銀獎<br />
    王楷茵同學 榮獲 鞋類設計銅獎<br />
    郭昶均同學 榮獲 服裝設計優選<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3694_8223293_32554.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3694_8223293_32554.jpg"></a> 
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3713_5580428_18017.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3713_5580428_18017.jpg"></a> 
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3714_6943943_18115.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3714_6943943_18115.jpg"></a> 
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3715_4893466_18141.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3715_4893466_18141.jpg"></a> 
    `
  },
  {
    date: "2024.10.14",
    category: "設計工作營",
    post: "設計探索體驗工作營 *2024國際工作營Part01-專業服裝畫設計營*",
    description: `
    授課教師 : <br />
    日本文化學園 高村是州 教授<br />
    專業翻譯:<br />
    文化學園國際交流處 郭乃嘉 老師<br />
    研習日期:2024/11/15-17<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3709_8157670_04374.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3709_8157670_04374.jpg"></a>
    `
  },
  {
    date: "2024.09.26",
    category: "比賽獲獎",
    post: "賀~2024 KFA高雄時尚大賞入圍",
    description: `
    -潘幸茹同學- <br />
    品牌名稱:CULTURELUX<br />
    作品主題:美麗之島<br />
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3706_964697_93028.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3706_964697_93028.jpg"></a> 
    `
  },
  {
    date: "2024.09.26",
    category: "比賽獲獎",
    post: "賀~服經系六位同學入圍pierre cardin青年設計師大獎賽",
    description: `
    高韶妘、薛宜蓁、陳底亞、陳威霖、蔡佩宸、張宇萱
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3705_2189424_92937.png"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3705_2189424_92937.png"></a> 
    `
  },
  {
    date: "2024.08.27",
    category: "學生創作",
    post: "賀",
    description: `
    服經系周立恒同學自創品牌CHOW des HOMME<br />
    獲選2024 臺北時裝週 SS25 品牌秀，<br />
    CHOW des HOMME獨立秀於10月18日在官方場地松山文創園區辦理。
    `
  },
  {
    date: "2024.08.15",
    category: "系務活動",
    post: "賀",
    description: `
    謝建騰助理教授通過教育部人文與藝術及設計學門教學實踐研究計畫-<br />
    結合問題式導向學習(PBL)與BOPPPS教學設計
    探討服裝設計師對材料的基本素養
    `
  },
  {
    date: "2024.08.15",
    category: "系務活動",
    post: "賀",
    description: `
    黃崇信助理教授通過教育部人文與藝術及設計學門教學實踐研究計畫-<br />
    全球化趨勢下強化在地特色之教學研究
    `
  },
  {
    date: "2024.07.18",
    category: "系務活動",
    post: "世界大學的典範University of Cambridge",
    description: `
    <iframe src="https://www.instagram.com/p/C9c3kF4yrB7/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2024.07.18",
    category: "系務活動",
    post: "倫敦深度移地教學",
    description: `
    <iframe src="https://www.instagram.com/p/C9Wq43pPw69/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2024.07.18",
    category: "系務活動",
    post: "倫敦 Greenwich",
    description: `
    <iframe src="https://www.instagram.com/p/C9gwWVSPiuM/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2024.06.04",
    category: "系務活動",
    post: "輝達NVIDA 全球合作夥伴大學",
    description: `
    <iframe src="https://www.instagram.com/p/C7x2-ORvBsk/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2024.03.13",
    category: "系務活動",
    post: "巴黎深度移地教學",
    description: `
    <iframe src="https://www.instagram.com/p/C4dLVDcP-wM/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2024.03.07",
    category: "設計工作營",
    post: "設計探索體驗工作營",
    description: `
    <iframe src="https://instagram.com/p/C4NnaryvOGH/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.08.06",
    category: "系務活動",
    post: "新生線上說明會 08/20",
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3465_1981199_67064.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3465_1981199_67064.jpg"></a> 
    `
  },
  {
    date: "2023.06.01",
    category: "學生創作",
    post: "新一代設計展",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2Fpfbid0gcqJrLXwXtysDyeQjHUKCjnM9yYaksD1HQhuj1Er9g6EwxcvDbo1CZZozRgxKjF8l&show_text=true&width=500" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2023.05.26",
    category: "學生創作",
    post: "新一代設計展",
    description: `
    <iframe src="https://www.instagram.com/p/CstdO2xNvf3/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.05.23",
    category: "學生創作",
    post: "新一代設計展",
    description: `
    <iframe src="https://www.instagram.com/p/CslRtAQPG5k/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.05.09",
    category: "設計工作營",
    post: "時裝週 造型構想與執行",
    description: `
    <iframe src="https://www.instagram.com/p/CsBR-d5SnX0/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.04.28",
    category: "學生創作",
    post: "數位時尚",
    description: `
    <iframe src="https://www.instagram.com/reel/CrlWkHjs590/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.04.27",
    category: "系務活動",
    post: "單獨招生",
    description: `
    <iframe src="https://www.instagram.com/reel/Cri4_qorbEb/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.03.31",
    category: "設計工作營",
    post: "Marangoni設計學院",
    description: `
    <iframe src="https://www.instagram.com/p/CqbwzXLSPv3/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.03.29",
    category: "臺北時裝週",
    post: "最佳展演學校獎",
    description: `
    <iframe src="https://www.instagram.com/p/CqYFDquyt8h/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.03.22",
    category: "臺北時裝週",
    post:
      "服飾設計與經營學系三年級周立恒同學獲選2023AW 臺北時裝週品牌秀發表設計作品",
    description: `
    服經系周立恒同學是臺北時裝週最年輕的品牌設計師，也是全國唯一在學
    學生獲選發表品牌秀的設計師。他所主理的服飾品牌 CHOW des HOMME，
    以雋永的現代感為特色，期望在追求時尚前衛設計感的同時，又不失百變
    穿搭的趣味性。

    周立恒 認為一件好的設計作品，不僅僅體現在 T 台走秀，而是讓更多人
    接受並穿戴。

    此次作品發表特別結合配件品牌 Zeit，不盲目追逐主流，金屬質感呈現
    未來感和獨特洗鍊風格，展現這個世代對於飾品的全新跨界美感。

    臺北時裝週 AW23 品牌秀
    ZEIT x CHOW des HOMME

    日期時間：112/3/27（一）
    10:30-11:00 入場
    11:00-11:30 開秀

    地點：松菸四號倉庫｜台北市信義區光復南路133號
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3382_6348106_87143.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3382_6348106_87143.jpg"></a> 
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3383_9828061_87161.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3383_9828061_87161.jpg"></a> 
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3384_7277330_87178.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3384_7277330_87178.jpg"></a> 
    `
  },
  {
    date: "2023.03.16",
    category: "系務活動",
    post: "單獨招生",
    description: `
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3379_8222877_69929.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3379_8222877_69929.jpg"></a> 
    `
  },
  {
    date: "2023.01.24",
    category: "系務活動",
    post: "Tokyo 這個充滿魅力的國際時尚城市",
    description: `
    <iframe src="https://www.instagram.com/p/CnzUozIS8UI/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.01.23",
    category: "系務活動",
    post: "Designer of dreams",
    description: `
    <iframe src="https://www.instagram.com/p/CnwcDrEy0fH/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.01.18",
    category: "系務活動",
    post: "日本文化服裝學院合作",
    description: `
    <iframe src="https://www.instagram.com/p/Cnj9LLry8V7/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2023.01.16",
    category: "系務活動",
    post: "2023 東京移地教學",
    description: `
    <iframe src="https://www.instagram.com/reel/Cne0uW3IdYJ/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2022.12.18",
    category: "系務活動",
    post: "亞洲時尚最前線「東京」",
    description: `
    <iframe src="https://www.instagram.com/p/CmSi2yXSMnK/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2022.11.13",
    category: "學生創作",
    post: "runway 服裝秀",
    description: `
    <iframe src="https://www.instagram.com/p/Ck4TgcJSU7T/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2022.10.31",
    category: "系務活動",
    post: "甜上癮 HOOKED FASHION SHOW",
    description: `
    2022/11/12(六)
    FASHION SHOW 時裝走秀
    東九道之驛-旗糖農創園區-8號倉庫
    高雄市旗山區忠孝街33號
    報到 13:00 - 13:30
    走秀 13:30 - 15:00
    <a target="_blank" href="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3080_3204668_23837.jpg"><img width="100%" src="https://fdm.kh.usc.edu.tw/var/file/35/1035/randimg/mobileadv_3080_3204668_23837.jpg"></a> 
    `
  },
  {
    date: "2022.07.22",
    category: "設計工作營",
    post: "新生工作營（台北場）",
    description: `
    <iframe src="https://www.instagram.com/p/CgT6_iBFGtJ/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2021.11.22",
    category: "學生創作",
    post: "高雄時尚大賞",
    description: `
    <iframe src="https://www.instagram.com/p/CWkfGLWvgqs/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2021.11.20",
    category: "比賽獲獎",
    post: "海峽兩岸服裝設計比賽",
    description: `
    <iframe src="https://www.instagram.com/p/CWe84u0PaRB/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2021.11.05",
    category: "系務活動",
    post: "一年一度的迎新活動來臨了🎉",
    description: `
    一年一度的迎新活動來臨了🎉
    歡迎新生加入我們FDM 大家庭✨✨
    -
    這次因為疫情取消了宿營兩天一夜，但也澆不熄新生們的熱情🔥
    因應萬聖節，各個工作人員、新生都全副武裝🎃
    每個遊戲關卡都精心規劃讓新生們體驗到不同的樂趣，還有晚上的烤肉晚會🥳
    透過迎新不僅讓新生們認識同屆朋友！也可以認識許多學長姊們！
    謝謝參與的老師、工作人員以及新生們，辛苦了✨
    <iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fvideos%2F396394621821308%2F&show_text=false&width=476&t=0" width="100%" height="476" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>`
  },
  {
    date: "2021.09.24",
    category: "臺北時裝週",
    post: "臺北時裝週 Taipei fashion week SS22",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F4733037866747607&show_text=true&width=500" width="100%" height="659" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2021.09.24",
    category: "比賽獲獎",
    post: "2021 ’’ 第二屆世界皮革大賽 ‘‘",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F4732552413462819&show_text=true&width=500" width="100%" height="480" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2021.03.28",
    category: "學生創作",
    post: "畢業靜態展",
    description: `
    <iframe src="https://www.instagram.com/p/CM9Bh5XDp_Q/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2021.03.26",
    category: "系務活動",
    post: "FDM時裝秀2021衣裳決賽",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F4171223876262345&width=500&show_text=true&height=729&appId" width="100%" height="729" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2021.03.18",
    category: "臺北時裝週",
    post:
      "臺北時裝週 官方評審也挑選出25套推薦作品，邀請大家為喜愛的設計新秀或優秀作品投票，之後會公布哪些可以參加明年台北時裝週設計新秀。",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F4149678535083546&width=500&show_text=true&height=749&appId" width="100%" height="749" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2021.03.16",
    category: "臺北時裝週",
    post: "作品發表",
    description: `
    <iframe src="https://www.instagram.com/p/CMe75Uajj6A/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2021.03.15",
    category: "臺北時裝週",
    post: "作品發表",
    description: `
    <iframe src="https://www.instagram.com/p/CMbEIPjj9ju/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2021.03.11",
    category: "臺北時裝週",
    post:
      "⚠️3/12敬請期待服飾設計與經營學系⚠️臺北時裝週 Taipei Fashion Week 大秀直播預告‼️",
    description:
      '<iframe src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fvideos%2F4130078687043531%2F&show_text=true&width=476" width="100%" height="591" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>'
  },
  {
    date: "2021.01.21",
    category: "系務活動",
    post:
      "FASHION DESIGN AND MERCHANDISING/服飾設計Fashion Show 2021期末發表 指導老師： @ednamode_tseng ",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3989280824456652&width=500&show_text=true&height=729&appId" width="100%" height="729" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.12.20",
    category: "學生創作",
    post: "服飾設計與經營學系畢製海報/名牌 designer: @kun_lin_xie ",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3907387462645989&width=500&show_text=true&height=382&appId" width="100%" height="382" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.12.18",
    category: "系務活動",
    post: "暖冬同樂",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3902639243120811&width=500&show_text=true&height=749&appId" width="100%" height="749" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.12.10",
    category: "系務活動",
    post: "「 舊物市集 」 歡迎大家約好朋友們一起來挖寶 ！！！🛒",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3880951928622876&width=500&show_text=true&height=674&appId" width="100%" height="674" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.11.29",
    category: "比賽獲獎",
    post: "陶瓷服裝創意大賽",
    description: `
    <iframe src="https://www.instagram.com/p/CIKlh_XjE5r/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2020.11.20",
    category: "學生創作",
    post: "InnoFashion",
    description: `
    <iframe src="https://www.instagram.com/p/CHzK-zKjPwc/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2020.11.07",
    category: "學生創作",
    post: "InnoFashion",
    description: `
    <iframe src="https://www.instagram.com/p/CHRX3vSDYdD/embed/captioned" width="100%" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
    `
  },
  {
    date: "2020.10.29",
    category: "設計工作營",
    post: "藍染講座暨工作體驗營",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3764726150245455&width=500&show_text=true&height=755&appId" width="100%" height="755" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.10.22",
    category: "比賽獲獎",
    post: "「2020 Look台味競賽」",
    description:
      '<iframe src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fvideos%2F3395090840716785%2F&show_text=true&width=560" width="100%" height="429" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>'
  },
  {
    date: "2020.10.17",
    category: "比賽獲獎",
    post: "「2020聚陽人文發展教育基金會 衣舊要愛創意設計競賽」",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3730082940376443&width=500&show_text=true&height=729&appId" width="100%" height="729" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.09.08",
    category: "比賽獲獎",
    post: "2020第一屆世界皮革創意設計大賽",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3608411672543571&width=500&show_text=true&height=729&appId" width="100%" height="729" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.07.21",
    category: "設計工作營",
    post: "FDM暑期工作營 流行服飾插畫手繪創作✨",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3458542434197163&width=500&show_text=true&height=729&appId" width="100%" height="729" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.06.30",
    category: "設計工作營",
    post: "FDM暑期工作營 服裝設計工作營 X 吳日云服裝設計師",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3397600653624675&width=500&show_text=true&height=729&appId" width="100%" height="729" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.06.30",
    category: "設計工作營",
    post: "FDM暑期工作營 袋包設計工作營X陳俞方袋包設計師",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3397555803629160&width=500&show_text=true&height=729&appId" width="100%" height="729" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.06.30",
    category: "設計工作營",
    post: "FDM暑期工作營 IG品牌經營工作營 X 楊攸仁(大仁哥)",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3397534506964623&width=500&show_text=true&height=729&appId" width="100%" height="729" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.06.20",
    category: "比賽獲獎",
    post: "本系施亮熙同學入圍2020台味服裝暨配件設計大賞決賽🎉",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3368641813187226&width=500&show_text=true&height=749&appId" width="100%" height="749" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.04.22",
    category: "學生創作",
    post: "2020 Apr. 防疫口罩妝容",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3215105351874207&width=500&show_text=true&height=770&appId" width="100%" height="770" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.04.19",
    category: "系務活動",
    post: "2020衣賞設計競賽",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3208094595908616&width=500&show_text=true&height=708&appId" width="100%" height="708" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.04.18",
    category: "系務活動",
    post: "2020衣賞設計競賽",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3205438030040935&width=500&show_text=true&height=708&appId" width="100%" height="708" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  },
  {
    date: "2020.02.21",
    category: "比賽獲獎",
    post: "第九屆儒鴻服裝設計競賽",
    description:
      '<iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ffdmshihchien%2Fposts%2F3072992259418851&width=500&show_text=true&height=693&appId" width="100%" height="693" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>'
  }
];

export default {
  props: {
    tab: String
  },
  setup(props) {
    const $q = useQuasar();

    function getItemsPerPage() {
      if ($q.screen.lt.sm) {
        return 2;
      }
      if ($q.screen.lt.md) {
        return 4;
      }
      return 6;
    }

    const pagination = ref({
      page: 1,
      rowsPerPage: getItemsPerPage()
    });

    watch(
      () => $q.screen.name,
      () => {
        pagination.value.rowsPerPage = getItemsPerPage();
      }
    );

    return {
      rows,
      filter: ref(props.tab === "所有訊息" ? "" : props.tab),
      pagination,
      columns,
      rowsPerPageOptions: computed(() => {
        return $q.screen.gt.xs ? ($q.screen.gt.sm ? [2, 4, 6] : [2, 4]) : [2];
      })
    };
  }
};
</script>
